$mol_app_hello_demo $mol_example_large
	title \Simpliest application
	sub /
		<= App $mol_app_hello
	aspects /
		\Application
